import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import {
  EPassportFormState,
  PASSPORT_FOREIGN,
  PASSPORT_RF,
} from "../../../../../store/slices/passportFormSliceCreator.ts";
import { PASSPORT_ERROR_MESSAGES } from "../utils";
import { useSMSFormState } from "../../SMSForm/hooks";
import { RoutesMap } from "../../../../../routes.tsx";
import { otpVerificationMutationFn } from "../../../../../api";
import { useNewAuthorization } from "../../useNewAuthorization";
import { usePhoneFormState } from "../../PhoneNumberForm/hooks";
import { usePassportFormState } from "./usePassportFormState.ts";
import { isNewAuthorization } from "../../../../../store/authorizationStore";
import { usePassportMutationReaction } from "./usePassportMutationReaction.ts";

export function usePassportFormStateReaction() {
  useNewAuthorization("passport");
  const navigate = useNavigate();
  const passportForm = usePassportFormState();
  const phoneForm = usePhoneFormState();
  const smsForm = useSMSFormState();

  const verifyPassport = usePassportMutationReaction();

  useEffect(() => {
    if (isNewAuthorization()
      && (passportForm.formState === EPassportFormState.validated
      || passportForm.formState === EPassportFormState.submitted)
    ) {
      return;
    }

    switch (passportForm.formState) {
      case EPassportFormState.validating: {
        if (passportForm.passportNumber.length === 0) {
          passportForm.setTextError(PASSPORT_ERROR_MESSAGES.passportIsEmpty);
          passportForm.setFormState(EPassportFormState.initial);
          return;
        }

        if (passportForm.passportType === PASSPORT_RF) {
          const onlyNumbers = passportForm.passportNumber.replace(/[^0-9]/g, "");
          if (onlyNumbers.length < 10) {
            passportForm.setTextError(PASSPORT_ERROR_MESSAGES.passportIsTooShort);
            passportForm.setFormState(EPassportFormState.initial);
            return;
          }
        }

        if ((passportForm.passportType === PASSPORT_FOREIGN) && passportForm.passportNumber.length < 6) {
          passportForm.setTextError(PASSPORT_ERROR_MESSAGES.passportIsTooShort);
          passportForm.setFormState(EPassportFormState.initial);
          return;
        }

        passportForm.setFormState(EPassportFormState.validated);
        return;
      }
      case EPassportFormState.validated: {
        // const consents: string[] = smsForm.consents;
        const mutationParams: Parameters<typeof otpVerificationMutationFn>[0] = {
          phone: phoneForm.getEscapedPhoneNumber(),
          code: smsForm.code,
          passport: passportForm.getEscapedPassportNumber(),
          // consents,
        };

        verifyPassport.mutate(mutationParams);
        passportForm.setFormState(EPassportFormState.submitting);
        return;
      }
      case EPassportFormState.submitted: {
        // navigate(RoutesMap.login.loading,);
        navigate(RoutesMap.login.pin);
        return;
      }
    }
  }, [passportForm.formState]);
}
